<template>
  <main class="common-container">
    <!-- <section class="page-title flash-title">
      <h2>{{ $t("chart1.tradingView") }}</h2>
    </section> -->

    <section class="explanation-container center">
      <p class="center-sentence">
        {{ $t("renewal.kibotZoneExp.descText1") }}<br />
        {{ $t("renewal.crossExp.descText1") }}<br />
        {{ $t("renewal.kibotZoneExp.descText3") }}<br />
        {{ $t("renewal.crossExp.descText2") }}
      </p>
    </section>
  </main>
</template>

<style lang="scss" scoped>
@import "@/assets/scss/pages/explanation/common_explanation.scss";
</style>
